// import RangeSliderComponent from '@apps/components/RangeSlider';
import { useMemo } from 'react';
import CheckboxFilter from '@apps/components/Filter/Checkbox';
import RangeSliderComponent from '@apps/components/Filter/PriceRange';
import { carFilter } from '@apps/config/car-filter.config';

/* eslint-disable @typescript-eslint/no-explicit-any */
export type QuickButtonGroupProps = {
  budgetList?: number[];
  monthlyPaymentList?: number[];
};

export const useQuickButtonGroup = ({
  budgetList,
  monthlyPaymentList,
}: QuickButtonGroupProps) => {
  const quickButton: {
    key: any;
    value: any;
    label: any;
    render: any;
    filterQuery?: any;
  }[] = useMemo(() => {
    return [
      {
        key: 'budget',
        label: 'Budget',
        value: '',
        render: (
          value: any,
          onChange: (value?: Array<string | number> | number | string) => void
        ) => {
          const budget = budgetList?.map((item) => {
            return { label: item.toString(), value: item };
          });

          return (
            <RangeSliderComponent
              onChange={onChange}
              options={budget}
              displayButton
              value={value}
            />
          );
        },
      },
      {
        key: 'monthly_payment',
        label: 'Monthly Payment',
        value: '',
        render: (
          value: any,
          onChange: (value?: Array<string | number> | number | string) => void
        ) => {
          const budget = monthlyPaymentList?.map((item) => {
            return { label: item.toString(), value: item };
          });

          return (
            <RangeSliderComponent
              onChange={onChange}
              displayButton
              options={budget}
              value={value}
            />
          );
        },
      },
      {
        key: 'body_type',
        label: 'Body Type',
        value: '',
        render: (value: any, onChange: (value?: any) => void) => {
          return (
            <CheckboxFilter
              onChange={onChange}
              options={carFilter}
              displayButton
              withIcon
              value={value}
              GridProps={{ xs: 6, spacing: 5 }}
              containerProps={{
                paddingX: '20px',
                paddingTop: '0px',
                overflow: 'auto',
                sx: {
                  '::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '::-webkit-scrollbar-thumb': {
                    backgroundColor: '#31ACBF',
                    borderRadius: '50px',
                  },
                },
              }}
            />
          );
        },
      },
      // {
      //   key: 'fuel_type',
      //   label: 'EV',
      //   value: '',
      //   filterQuery: {
      //     body_type: 'ev'
      //   }
      // }
    ];
  }, []);

  return quickButton;
};

export type QuickFilterValueType = {
  type: 'min_budget' | 'max_budget' | 'body_type';
  value: number | string[];
};

export type QuickFilterType = {
  title: string;
  key: string;
  value: QuickFilterValueType[];
};

export const quickFilters: QuickFilterType[] = [
  {
    key: 'budget',
    title: `0-40K`,
    value: [
      { type: 'min_budget', value: 0 },
      { type: 'max_budget', value: 40000 },
    ],
  },
  {
    key: 'budget',
    title: `40-60K`,
    value: [
      { type: 'min_budget', value: 40000 },
      { type: 'max_budget', value: 60000 },
    ],
  },
  {
    key: 'budget',
    title: `60-90K`,
    value: [
      { type: 'min_budget', value: 60000 },
      { type: 'max_budget', value: 90000 },
    ],
  },
  {
    key: 'budget',
    title: `90-120K`,
    value: [
      { type: 'min_budget', value: 90000 },
      { type: 'max_budget', value: 120000 },
    ],
  },
  {
    key: 'body_type',
    title: `Sedan`,
    value: [{ type: 'body_type', value: ['sedan'] }],
  },
  {
    key: 'body_type',
    title: `Hatchback`,
    value: [{ type: 'body_type', value: ['hatchback'] }],
  },
  {
    key: 'body_type',
    title: `MPV`,
    value: [{ type: 'body_type', value: ['mpv'] }],
  },
  {
    key: 'body_type',
    title: `SUV`,
    value: [{ type: 'body_type', value: ['suv'] }],
  },
];
